import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { cn } from '@/common/utils/cn'
import { TriangleIcon } from 'lucide-react'
import { useState } from 'react'

export interface MessageWithErrorExtras {
  messages: string[]
  errorExtras: {
    parsed_reason: string
    raw_reason: string
  } | null
}

interface ModalMessageWithErrorExtrasProps {
  errors: MessageWithErrorExtras | boolean
  setErrors: React.Dispatch<React.SetStateAction<MessageWithErrorExtras | boolean>>
  onClose?: () => void
  title?: string
  footer?: string
  message?: string
}

export const ModalMessageWithErrorExtras = ({
  errors,
  setErrors,
  onClose,
  title,
  footer,
}: ModalMessageWithErrorExtrasProps) => {
  const [codeBlockOpened, setCodeBlockOpened] = useState(false)

  const handleClose = () => {
    setErrors(false)
    setCodeBlockOpened(false)
  }

  return (
    <Modal
      isOpen={!!errors}
      setIsOpen={handleClose}
      onCancel={onClose}
      onConfirm={() => {
        setErrors(false)
        onClose?.()
      }}
      title={
        title ||
        (typeof errors === 'object'
          ? errors?.messages?.length > 1 || errors?.errorExtras?.parsed_reason
            ? errors?.messages?.[0]
            : ' '
          : ' ')
      }
      titleClass={cn('text-danger-soft', {
        'text-center min-w-[32rem] bg-white-200 -m-6 mb-6 p-6 rounded-t-md':
          typeof errors === 'object' && (errors?.messages?.length > 1 || errors?.errorExtras?.parsed_reason),
      })}
      showClose={false}
      footer={footer || 'Entendido!'}
      dataTestid="message_confirm_button"
      subtitle={
        <div className="flex max-w-[29rem] flex-col gap-3">
          {typeof errors === 'object' &&
            (errors.messages?.length > 1 || errors?.errorExtras?.parsed_reason
              ? errors.messages.slice(1)
              : errors.messages
            )?.map((message, index) => (
              <p key={index} className="text-[16px] text-danger-soft">
                {message}
              </p>
            ))}

          {typeof errors === 'object' && errors.errorExtras && (
            <>
              <p className="text-[16px] text-danger-soft">{errors.errorExtras.parsed_reason}</p>

              {errors.errorExtras.raw_reason && (
                <div className="flex items-start gap-x-2">
                  <Button variant="link-white" onClick={() => setCodeBlockOpened(!codeBlockOpened)}>
                    <TriangleIcon
                      size={16}
                      className={cn('fill-white-800 rotate-90', {
                        'rotate-180': codeBlockOpened,
                      })}
                    />
                  </Button>

                  <div className="flex w-full flex-col gap-y-2 pr-4">
                    <p className="text-white-400">Request recebido:</p>
                    <div
                      className={cn('h-0 max-h-[calc(100dvh-20rem)] overflow-y-auto', {
                        'h-auto': codeBlockOpened,
                      })}
                    >
                      <pre className="bg-white-100 p-3 rounded-md">{errors.errorExtras.raw_reason}</pre>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      }
    />
  )
}
